(function ($) {
  $.urlParam = function (name) {
    var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(
      window.location.href
    );
    if (results == null) {
      return null;
    } else {
      return decodeURI(results[1]) || 0;
    }
  };
  $(window).load(function () {
    var searchParams = $.urlParam("topicId");
    if (searchParams) {
      var topicParam = searchParams;
      var optionToClick = $(
        '.select--option[data-value="' +
          topicParam +
          '"][data-taxonomy="focal_point"]'
      );
      if (optionToClick.length > 0) {
        optionToClick.trigger("click");
      }
    }
  });
})(jQuery);
